export enum PlasticsHardwareItemStatus {
	Active = 'Active',
	Obsolete = 'Obsolete',
}